import { z } from "zod/v4"
import type { DocumentSnapshotLike } from "../firestore"
import { CreatedAt, UpdatedAt } from "./system"

export const CoinPackPurchaseCountDocumentMeta = z.object({
  user_id: z.string().describe("ユーザーID"),
  coin_pack_id: z.string().describe("コインパックID"),
  purchase_count: z.number().min(0).describe("購入回数"),
})

export type CoinPackPurchaseCountDocumentMeta = z.infer<typeof CoinPackPurchaseCountDocumentMeta>

export const CoinPackPurchaseCountDocumentBody = z.intersection(
  CoinPackPurchaseCountDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export type CoinPackPurchaseCountDocumentBody = z.infer<typeof CoinPackPurchaseCountDocumentBody>

export const CoinPackPurchaseCountDocument = z.intersection(
  CoinPackPurchaseCountDocumentBody,
  z.object({
    id: z.string().describe("コインパック購入回数ID"),
  })
)
export type CoinPackPurchaseCountDocument = z.infer<typeof CoinPackPurchaseCountDocument>

export class CoinPackPurchaseCountDocuments {
  static toDocumentData(doc: CoinPackPurchaseCountDocument): object {
    return {
      ...doc,
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): CoinPackPurchaseCountDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: doc.id,
      user_id: data["user_id"],
      coin_pack_id: data["coin_pack_id"],
      purchase_count: data["purchase_count"] ?? 0,
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}
